import {
  LayoutDashboard,
  FileText,
  Users,
  UserCog,
  type LucideIcon
} from 'lucide-react';

export type Role = 'doctor' | 'user';

interface NavItem {
  href: string;
  label: string;
  icon: LucideIcon;
  roles: Role[];
}

interface NavigationConfig {
  mainNav: NavItem[];
}

export const navigationConfig: NavigationConfig = {
  mainNav: [
    {
      href: '/dashboard',
      label: 'navigation.dashboard',
      icon: LayoutDashboard,
      roles: ['doctor', 'user']
    },
    {
      href: '/prescriptions',
      label: 'navigation.prescriptions',
      icon: FileText,
      roles: ['doctor', 'user']
    },
    {
      href: '/patients',
      label: 'navigation.patients',
      icon: Users,
      roles: ['doctor', 'user']
    },
    {
      href: '/profile',
      label: 'navigation.profile',
      icon: UserCog,
      roles: ['doctor', 'user']
    },
  ]
};